import { useQuery } from '@tanstack/react-query';
import { recipeService } from '@/services/recipe';
import { RECIPES } from '@/constants/queryKeys';

/**
 * Hook to fetch recipes for composition management
 * Optimizes fetching based on whether we need all recipes or specific ones
 */
export const useCompositionRecipes = (specificRecipeIds?: string[]) => {
  // If we have specific recipe IDs, fetch only those
  const specificRecipesQuery = useQuery({
    queryKey: ['recipes-by-ids', specificRecipeIds],
    queryFn: () => recipeService.getRecipesByIds(specificRecipeIds!),
    enabled: !!specificRecipeIds && specificRecipeIds.length > 0,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  // For forms and creation, fetch all recipes
  const allRecipesQuery = useQuery({
    queryKey: [RECIPES],
    queryFn: recipeService.getRecipes,
    enabled: !specificRecipeIds, // Only fetch all when we don't have specific IDs
    staleTime: 5 * 60 * 1000,
  });

  if (specificRecipeIds) {
    return {
      recipes: specificRecipesQuery.data || [],
      isLoading: specificRecipesQuery.isLoading,
      error: specificRecipesQuery.error,
      refetch: specificRecipesQuery.refetch,
    };
  }

  return {
    recipes: allRecipesQuery.data || [],
    isLoading: allRecipesQuery.isLoading,
    error: allRecipesQuery.error,
    refetch: allRecipesQuery.refetch,
  };
};